import { render, staticRenderFns } from "./UnsereReferenzen.vue?vue&type=template&id=3021b17c&scoped=true&"
import script from "./UnsereReferenzen.vue?vue&type=script&lang=js&"
export * from "./UnsereReferenzen.vue?vue&type=script&lang=js&"
import style0 from "./UnsereReferenzen.vue?vue&type=style&index=0&id=3021b17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3021b17c",
  null
  
)

export default component.exports